export { default as PracticalInformation } from './practical_information'
export { default as Paiements } from './paiements'
export { default as Menu } from './menu'
